"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    downloadRecords: "Download Records",
    downloadTextForm: "Download Records In Text Form",
    copyTextForm: "Copy Records In Text Form",
    downloadMd: "Download Records In Markdown",
    copyMd: "Copy Records In Markdown",
};
